export default __webpack_public_path__ + "static/media/icon-chaveiro.8ae87b73.svg";